import { Toast } from 'bootstrap'

document.addEventListener("turbolinks:load", function () {
  if (document.getElementById('continueFieldsForm')?.length > 0) {
    const form = document.getElementById('continueFieldsForm')
    form.addEventListener('submit', event => {
      event.preventDefault()
      const authToken = document.getElementsByTagName('meta')[2].content
      const headers = { 'X-CSRF-Token': authToken }
      let payload = {}
      document.querySelectorAll('.identification-field').forEach(element => {
        const value = element.value
        const key = element.getAttribute('data-field-name')
        payload[key] = value
      })
      payload["form_name"] = document.getElementById('form-name').value
      axios.post('/saas/self_applied_forms/find', payload, { headers })
        .then(response => {
          const selfAppliedFormId = response.data.self_applied_form_id
          const currentUrl = window.location.href
          const baseUrl = currentUrl.split('/continue')[0]
          window.location.replace(`${baseUrl}/${selfAppliedFormId}/questions`)
        })
        .catch(error => {
          var myToastEl = document.getElementById('not-found-toast')
          var myToast = new Toast(myToastEl, {})
          myToast.show()
        })
    })
  }
})
